import { Component, OnInit, ViewEncapsulation, } from '@angular/core';
import { Router } from '@angular/router';
import { HttpRequestsService } from 'src/app/services/http-requests.service';
import { MatDialog } from '@angular/material/dialog';
import { LqDialogComponent } from '../lq-dialog/lq-dialog.component';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { KeycloakService } from 'keycloak-angular';
import { Timeline, ITimelineOptions } from '@knight-lab/timelinejs';

@Component({
  selector: 'app-city-learning-process',
  templateUrl: './city-learning-process.component.html',
  styleUrls: ['./city-learning-process.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class CityLearningProcessComponent implements OnInit {
  public city = history.state.city;
  public country = history.state.country;

  public events = [];
  public lqData: any = [];
  public color: string = '';
  public activity: string = '';
  public cities2: any[] = [];
  public metaLQ: any[] = [];

  public lqDialogData: any;
  public activityDialogData: any;

  public contentID: string = '';
  public activityID: string = '';

  public allowed: boolean = false;  // set true when allowed to edit/delete city content depending on the Living Labs Role in KeycloakService

  public isLQ: boolean;
  public isAct: boolean;

  constructor(private keycloak: KeycloakService, private req: HttpRequestsService<any>, private router: Router, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.req.getCitiesLQs(this.city).subscribe((res) => {
      this.lqData = res;
      this.data();
    });

    if (this.keycloak.getUserRoles().includes('MODERATOR')) {
      this.allowed = true;
    } else {
      const keycloakInstance = this.keycloak.getKeycloakInstance();
      if (keycloakInstance.authenticated) {
        this.keycloak.loadUserProfile().then(profile => {
          if (profile['attributes'].City[0] == this.city) {
            this.allowed = true;
          } else {
            this.allowed = false;
          };
        });
      } else {
        this.allowed = false;
      }
    }
  }

  data(): void {
    this.events = [];
    const options: ITimelineOptions = {
      language: "en",
      start_at_end: false,
      start_at_slide: 0,
      initial_zoom: 1,
      stack_events: false,
    }

    for (let i = 0; i < this.lqData.length; i++) {
      let newEvent = {
        start_date: {
          year: `${this.lqData[i].Date.substring(0, 4)}`,
          month: `${this.lqData[i].Date.substring(5, 7)}`,
          day: `${this.lqData[i].Date.substring(8, 10)}`,
        },
        text: {
          headline: `${this.lqData[i].LQ}`
        },
        background: {
          color: "#99c199"
        },
        group: `${this.lqData[i].LQ.substring(0, 200)}...`,
        unique_id: `${this.lqData[i].ID}`,
      }
      this.events.push(newEvent);

      for (let j = 0; j < this.lqData[i].Activities.length; j++) {
        if (this.lqData[i].Activities[j][3].substring(0, 3) === 'GIA') {
          this.color = '#648528';
        }
        else if (this.lqData[i].Activities[j][3].substring(0, 3) === 'CIA') {
          this.color = '#0E4B24';
        }
        else if (this.lqData[i].Activities[j][3].substring(0, 3) === 'DIA') {
          this.color = '#59C6F2';
        }
        else if (this.lqData[i].Activities[j][3].substring(0, 3) === 'PIA') {
          this.color = '#0F70B7';
        }
        else {
          this.color = '#C7D40B';
        }
        let newEvent = {
          start_date: {
            year: `${this.lqData[i].Activities[j][1].substring(0, 4)}`,
            month: `${this.lqData[i].Activities[j][1].substring(5, 7)}`,
            day: `${this.lqData[i].Activities[j][1].substring(8, 10)}`,
            hour: (2 * j) + 1//convention to distinguish events
          },
          text: {
            headline: `${this.lqData[i].Activities[j][0]}`,
            text: `Learning Question: ${this.lqData[i].LQ}`
          },
          group: `${this.lqData[i].LQ.substring(0, 200)}...`,
          background: {
            color: `${this.color}`
          },
          unique_id: `${this.lqData[i].Activities[j][2]}`,
        }


        this.events.push(newEvent);
      }
    }

    const timelineData = {
      events: this.events
    }

    const timeline = new Timeline('timeline-embed', timelineData, options);
    timeline.on("change", (event) => {
      if (event.target.config.event_dict[event.target.current_id].background.color === "#99c199") {
        this.isLQ = true;
        this.isAct = false;
        this.contentID = event.target.current_id;
        this.req.getLQData(this.contentID).subscribe((res) => this.lqDialogData = res);
      }
      else {
        this.isLQ = false;
        this.isAct = true;
        this.activityID = event.target.current_id;
        this.activity = event.target.config.event_dict[event.target.current_id].text.headline;
        this.req.getActivityData(this.activity, this.city).subscribe((res) => this.activityDialogData = res[0]);
      }
    });
  }
  addQuestionContent() {
    this.router.navigateByUrl(`${this.city}/Question-Form`, { state: { city: this.city, country: this.country } });
  }

  addActionContent() {
    this.router.navigateByUrl(`${this.city}/Activity-Form`, { state: { city: this.city, country: this.country } });
  }

  openLQDialog() {
    this.cities2 = [];
    this.metaLQ = [];

    for (let i = 0; i < this.lqDialogData.length; i++) {
      if (this.lqDialogData[i].Cities2 != undefined) {
        this.cities2.push(this.lqDialogData[i].Cities2);
      }
    }
    for (let i = 0; i < this.lqDialogData.length; i++) {
      if (this.lqDialogData[i].Meta_LQ != undefined) {
        this.metaLQ.push(this.lqDialogData[i].Meta_LQ);
      }
    }
    this.dialog.open(LqDialogComponent, { autoFocus: false, disableClose: false, data: { city: this.city, id: this.contentID, meta: this.lqDialogData[0].Meta, summary: this.lqDialogData[0].Summ, lq: this.lqDialogData[0].LQ, cities1: this.lqDialogData[0].Cities1, metaLQ: this.metaLQ, cities2: this.cities2, activities: this.lqDialogData[0].Activities } });
  }

  openActivityDialog() {
    this.dialog.open(ActivityDialogComponent, { autoFocus: false, disableClose: false, data: { city: this.city, id: this.activityID, activity: this.activityDialogData.Act, summary: this.activityDialogData.Summ, cities: this.activityDialogData.Cities, lq: this.activityDialogData.LQ, actions: this.activityDialogData.Actions } });
  }

  openInfoDialog() {
    this.dialog.open(InfoDialogComponent, { autoFocus: false, disableClose: false })
  }
}